import React from 'react'

import { ClassValue } from 'clsx'
import { cn } from '@/utilities/ui'

export type DataWrapperProps = {
    className?: ClassValue
    url: string
    width?: number
    height?: number
    blockType: 'datawrapper'
}

export const DataWrapperBlock: React.FC<DataWrapperProps> = ({ url, height, width, className }) => {
    // Url is like https://datawrapper.dwcdn.net/wD2Sp/2/
    const datawrapperId = url.split('/').slice(-2)[0]
    return (
        <iframe
            data-src={url}
            title='Datawrapper chart'
            id={`datawrapper-chart-${datawrapperId}`}
            width={width}
            height={height}
            loading='lazy'
            scrolling='no'
            className={cn('max-w-full my-2', className)}
            src={url}
            sandbox='allow-scripts allow-same-origin'
        ></iframe>
    )
}
